import { empty, not, prop } from 'ramda';

const DOCUMENT_TYPES = {
  '00': {
    codeParameter: 'DNI',
    nameParameter: 'Documento Nacional de Identificación',
    code: '00',
    maxLength: 8,
    numeric: true,
    fixed: true,
  },
  '01': {
    codeParameter: 'CE',
    nameParameter: 'Carné de Extranjería',
    code: '01',
    maxLength: 13,
    minLength: 4,
    numeric: false,
    fixed: false,
  },
  '03': {
    codeParameter: 'CMT',
    nameParameter: 'Carné de autorización del Ministerio de Trabajo y Promoción Social',
    code: '03',
    maxLength: 12,
    minLength: 4,
    numeric: false,
    fixed: false,
  },
  '04': {
    codeParameter: 'PAS',
    nameParameter: 'Pasaporte',
    code: '04',
    maxLength: 12,
    minLength: 4,
    numeric: false,
    fixed: false,
  },
  '06': {
    codeParameter: 'PTP',
    nameParameter: 'Carné de Permiso Temporal de Permanencia',
    code: '06',
    maxLength: 9,
    minLength: 4,
    numeric: true,
    fixed: false,
  },
  '07': {
    codeParameter: 'CIRRE',
    nameParameter: 'Carné de Identidad de Relaciones Exteriores',
    code: '07',
    maxLength: 8,
    minLength: 4,
    numeric: true,
    fixed: false,
  },
  '08': {
    codeParameter: 'CIE',
    nameParameter: 'Cédula de Identidad del Extranjero',
    code: '08',
    maxLength: 13,
    minLength: 4,
    numeric: false,
    fixed: false,
  },
  '09': {
    codeParameter: 'CSREF',
    nameParameter: 'Carné de Solicitante de Refugio',
    code: '09',
    maxLength: 9,
    minLength: 4,
    numeric: true,
    fixed: false,
  },
  '10': {
    codeParameter: 'CPP',
    nameParameter: 'Carnet Temporal de Trabajo',
    code: '10',
    maxLength: 9,
    minLength: 4,
    numeric: true,
    fixed: false,
  },
};

export const getMaxLength = documentType => prop('maxLength', DOCUMENT_TYPES[documentType]);
export const getMinLength = documentType => prop('minLength', DOCUMENT_TYPES[documentType]);
export const isNumeric = documentType => prop('numeric', DOCUMENT_TYPES[documentType]);
export const isFixed = documentType => prop('fixed', DOCUMENT_TYPES[documentType]);

const validateNoEmpty = value => value && not(empty(value));

export const validateDocumentType = documentType => validateNoEmpty(documentType);

const regexNumeric = '[0-9]';
const regexAlphanumeric = '[0-9A-Z]';

export const validateDocumentNumber = (documentNumber, documentType) => {
  if ( not(validateNoEmpty(documentNumber)) ) return false;

  const maxLength = getMaxLength(documentType);
  const minLength = getMinLength(documentType);
  const _isNumeric = isNumeric(documentType);
  const _isFixed = isFixed(documentType);

  if ( _isNumeric && _isFixed ) {
    const regex = new RegExp(`^${regexNumeric}{${maxLength}}$`);
    return regex.test(documentNumber);
  }

  if ( _isNumeric ) {
    const regex = new RegExp(`^${regexNumeric}{${minLength},${maxLength}}$`);
    return regex.test(documentNumber);
  }

  if ( _isFixed ) {
    const regex = new RegExp(`^${regexAlphanumeric}{${maxLength}}$`);
    return regex.test(documentNumber);
  }

  const regex = new RegExp(`^${regexAlphanumeric}{${minLength},${maxLength}}$`);
  return regex.test(documentNumber);
};